import { ALL_MODELS } from "../constants";
import { RidgeRegression } from "./RidgeRegression";

export class LinearRegression extends RidgeRegression {
  modelName = ALL_MODELS.linReg;
  lambdas = [0.01];
}
